export const NBSP = '\u00A0';
export const RUB = '\u20bd';
export const PERCENT = '\u0025';
